module.exports = __webpack_public_path__ + "static/stopien_zly-7944054c37fe89defbaae789b08ee315.jpg";